import React, { useState, useEffect, useRef } from 'react'
import arcmIcons from '../Icons'
import { Ajax } from '../common'
import { makeApiRequest } from '../common'
import { Link } from 'react-router-dom'
import Onboarding from '../views/Onboarding'
import ArchiveSettings from '../views/ArchiveSettings'
import AwsConfigure from '../views/AwsConfigure'
import ArchiveDetails from '../views/ArchiveDetails'
import Logs from '../views/Logs'
import Modal from '../components/core/Modal'
import ExportOrders from '../views/ExportOrders'
import connectionContext from '../context/connectionContext'

const Settings = () => {
  const [isOnboardingComplete, setIsOnboardingComplete] = useState(false)
  const [AdminSettings, setAdminSettings] = useState(archm_admin.archm_settings)
  const [activeView, setActiveView] = useState('dashboard_settings')
  const [isOpen, setIsOpen] = useState(false)
  const [isArchiveFailedOpen, setIsArchiveFailedOpen] = useState(false)
  const [archiveFailMeassage, setArchiveFailMeassage] = useState('')
  const [archiving, setArchiving] = useState(false)
  const [awsConnection, setAwsConnection] = useState(false)
  const [initialLoading, setInitialLoading] = useState(false)
  const [rdsCredential, setRdsCredential] = useState({})
  const [archiveSettings, setArchiveSettings] = useState({})
  const [queuedOrders, setQueuedOrders] = useState(0)
  const [totalOrders, setTotalOrders] = useState(0)
  const [percentage, setPercentage] = useState(0)
  const [archiveIntervalId, setArchiveIntervalId] = useState(null)
  const [saveBtnLoading, setSaveBtnLoading] = useState(false)
  const [isPro, setIsPro] = useState('')
  const archiveIntervalRef = useRef(null)

  const handleAwsconnection = status => {
    setAwsConnection(status)
  }

  const handleToggleModal = () => {
    setIsOpen(!isOpen)
  }

  const handleArchiveingChange = archive => {
    setArchiving(archive)
  }

  const handleArchiveFailedToggleModal = () => {
    setIsArchiveFailedOpen(!isArchiveFailedOpen)
  }

  const handleArchiveing = archive => {
    setArchiving(archive)
    setIsOpen(!isOpen)
  }

  const handleOnboardingComplete = status => {
    setIsOnboardingComplete(status)
  }

  const handleViewChange = view => {
    if (
      'dashboard_settings' === view &&
      (Object.entries(archiveSettings).length === 0 ||
        Object.entries(rdsCredential).length === 0)
    ) {
      handleDashboardView()
    }
    setActiveView(view)
    localStorage.setItem('arcm_active_view', view)
  }

  const saveAdminSettings = async () => {
    setSaveBtnLoading(true)
    const saveSettings = await makeApiRequest('settings', 'POST', AdminSettings);
    setSaveBtnLoading(false)
    console.log(saveSettings)
  }

  const handleArchiveViewSettings = () => {
    handleViewChange('dashboard_settings')
    handleViewChange('archiving_details')
    handleArchiveingChange('archiving__start')
    handleToggleModal()
  }

  const handleDashboardView = async () => {
    setInitialLoading(true)
    const rdsConnection = await makeApiRequest('connection-status', 'GET');
    console.log(rdsConnection)
    if (rdsConnection.success) {
      handleAwsconnection(true)
      handleOnboardingComplete(true)
      setRdsCredential({ ...rdsConnection.data.rds_credential })
      setArchiveSettings({ ...rdsConnection.data.archive_settings })
    } else {
      handleAwsconnection(false)
      handleOnboardingComplete(false)
    }
    setInitialLoading(false)
  }

  const calculatePercentage = (queuedOrders, totalOrders) => {
    if (totalOrders === 0) return 0 // Avoid division by zero
    return Math.round((queuedOrders / totalOrders) * 100)
  }

  const fetchArchivingStatus = async () => {
    const archivingStatus = await makeApiRequest('archive-post', 'POST');
    console.log(archivingStatus)
    if (archivingStatus.success) {
      const { remotePostCount, mainPostCount, archiveLoop } =
        archivingStatus.data
      if (archiveLoop) {
        console.log(remotePostCount, mainPostCount)
        setQueuedOrders(remotePostCount)
        setTotalOrders(mainPostCount)
        const calculatedPercentage = calculatePercentage(
          remotePostCount,
          mainPostCount
        )
        setPercentage(calculatedPercentage)
        fetchArchivingStatus()
      } else {
        handleViewChange('dashboard_settings')
        handleArchiveingChange('archiving__complete')
      }
    } else {
      handleViewChange('dashboard_settings')
      handleArchiveingChange('archive__failed')
      setArchiveFailMeassage(archivingStatus.message)
    }
  }

  const falshDoor = () => {
    alert('Please upgrade to pro')
  }

  const redirectProPage = () => {
    const url = "https://archivemaster.pro/";
    window.open(url, '_blank');
  }

  useEffect(() => {
    console.log(archm_admin)
    console.log(appObj)
    setIsPro(archm_admin.is_pro)
    handleDashboardView()
  }, [])

  useEffect(() => {
    if ('archiving__start' === archiving) {
      setQueuedOrders(0)
      setTotalOrders(0)
      setPercentage(0)
      fetchArchivingStatus()
    }

    if ('archive__failed' === archiving) {
      handleArchiveFailedToggleModal()
    }
  }, [archiving])

  return (
    <div className='wooarchive-settings'>
      {activeView === 'dashboard_settings' ? (
        initialLoading ? (
          <div class='arcm-absolute arcm-w-full arcm-h-full arcm-top-[50%] arcm-left-[50%] -arcm-translate-x-[50px] -arcm-translate-y-[50px]'>
            {arcmIcons.SpinningAnimation}
          </div>
        ) : (
          <>
            {!isOnboardingComplete ? (
              <Onboarding onvVeiwChange={handleViewChange} />
            ) : (
              <>
                <div className='wooarchive-settings__dashboard'>
                  <div className='header arcm-flex-wrap arcm-flex arcm-items-center arcm-justify-between arcm-gap-2 arcm-mb-4'>
                    <h4 className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold'>
                      Dashboard
                    </h4>

                    <div className='arcm-inline-flex arcm-items-center arcm-gap-4 sm:arcm-gap-8 arcm-ml-auto'>
                      <button
                        onClick={() => handleViewChange('archive_settings')}
                        className='arcm-text-xs sm:arcm-text-sm arcm-text-gray-800 arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9]'
                      >
                        <span className='icon'>{arcmIcons.settings}</span>
                        Archive settings
                      </button>
                      <Link
                        to='logs'
                        className='arcm-text-xs sm:arcm-text-sm arcm-text-gray-800 arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9]'
                        type='button'
                      >
                        <span className='icon'>{arcmIcons.logs}</span>
                        Log
                      </Link>
                      <button onClick={redirectProPage} className='arcm-btn-bounce arcm-text-xs sm:arcm-text-sm arcm-text-[#A34AE8] arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1'>
                        <span className='icon arcm-inline-block'>
                          {arcmIcons.upgrade}
                        </span>
                        Upgrade Now
                      </button>
                    </div>
                  </div>

                  <div className='ready-archive arcm-mb-4 arcm-px-5 arcm-py-6 sm:arcm-px-8 sm:arcm-py-10 md:arcm-px-10 md:arcm-py-12 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-gray-200'>
                    {(archiving === false ||
                      'archive__failed' === archiving) && (
                      <>
                        <div className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold arcm-mb-1.5'>
                          Ready to Archive
                        </div>
                        <div className='arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-4'>
                          The archive setup is completed! You can archive now
                        </div>
                        <button
                          onClick={handleToggleModal}
                          className='arcm-text-white arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-min-w-[160px] arcm-px-4 arcm-py-2.5 arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                        >
                          <span>Archive Now</span>
                        </button>
                      </>
                    )}

                    {archiving === 'archiving__start' && (
                      <>
                        <div className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold arcm-mb-1.5'>
                          Archiving ({percentage})%....
                        </div>
                        <div className='archive-progress__bar arcm-mb-4 arcm-max-w-[411px] arcm-relative arcm-h-5 arcm-pr-[471px] arcm-bg-[#d8dee2] arcm-rounded arcm-overflow-hidden'>
                          <div
                            className='archive-progress__bar-inner arcm-absolute arcm-top-0 arcm-left-0 arcm-h-full arcm-bg-emerald-500'
                            style={{ width: percentage + '%' }}
                          ></div>
                        </div>
                        <button
                          onClick={() => handleViewChange('archiving_details')}
                          className='arcm-text-[#3858e9] arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-min-w-[160px] arcm-px-4 arcm-py-2.5 arcm-bg-white arcm-border arcm-border-[#3858e9] arcm-rounded-lg arcm-transition-all hover:arcm-bg-[#3858e9] hover:arcm-text-white'
                        >
                          <span>View Details</span>
                        </button>
                        <div className='arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mt-4'>
                          You can continue using your site as usual. The
                          archiving process will run in the background
                        </div>
                      </>
                    )}

                    {archiving === 'archiving__cancel' && (
                      <>
                        <div className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold arcm-mb-1.5'>
                          Archiving{' '}
                          <span className='arcm-text-red-500'>Cancelled</span>
                        </div>
                        <div className='arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-4 arcm-flex arcm-items-center arcm-gap-1'>
                          {' '}
                          {arcmIcons.warning} Archiving has been cancelled{' '}
                          <a
                            onClick={() =>
                              handleViewChange('archiving_details')
                            }
                            className='arcm-text-[#3858e9] arcm-cursor-pointer arcm-text-sm arcm-font-semibold underline'
                          >
                            View Details
                          </a>
                        </div>
                        <button
                          onClick={handleToggleModal}
                          className='arcm-text-white arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-min-w-[160px] arcm-px-4 arcm-py-2.5 arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                        >
                          <span>Archive Now</span>
                        </button>
                      </>
                    )}

                    {archiving === 'archiving__complete' && (
                      <>
                        <div className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold arcm-mb-1.5'>
                          Archiving Complete
                        </div>
                        <button
                          onClick={handleToggleModal}
                          className='arcm-text-white arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-min-w-[160px] arcm-px-4 arcm-py-2.5 arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                        >
                          <span>Archive Now</span>
                        </button>
                      </>
                    )}
                  </div>

                  <div className='ready-archive arcm-px-5 arcm-py-6 sm:arcm-px-8 sm:arcm-py-10 md:arcm-px-10 md:arcm-py-12 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-gray-200'>
                    <div className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold arcm-mb-5'>
                      Ready to Archive
                    </div>
                    <table className='arcm-w-full arcm-max-w-[523px]'>
                      <tbody>
                        <tr>
                          <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                            <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='icon'>{arcmIcons.archive}</span>{' '}
                              Archive Status:
                            </div>
                          </td>
                          <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                            <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='icon'>
                                {arcmIcons.checkCircle}
                              </span>

                              {archiving === false && 'Ready to Archive'}
                              {archiving === 'archiving__start' && (
                                <>
                                  <p>
                                    Archiving -{' '}
                                    <span
                                      class='arcm-text-[#67e8f9] arcm-cursor-pointer'
                                      onClick={() =>
                                        handleViewChange('archiving_details')
                                      }
                                    >
                                      Details
                                    </span>
                                  </p>
                                </>
                              )}
                              {archiving === 'archiving__complete' &&
                                'Archive Complete'}
                              {archiving === 'archiving__cancel' &&
                                'Archiving Cancelled'}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                            <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='icon'>{arcmIcons.database}</span>{' '}
                              Remote Database:
                            </div>
                          </td>
                          <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                            <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='arcm-w-3 arcm-h-3 arcm-bg-[#27d935] arcm-rounded-full'>
                                {' '}
                              </span>{' '}
                              Connected to RDS {arcmIcons.aws}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                            <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='icon'>{arcmIcons.folder}</span>{' '}
                              Post Type:
                            </div>
                          </td>
                          <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                            <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                              {' '}
                              WooCommerce Orders
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                            <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='icon'>{arcmIcons.calendar}</span>{' '}
                              Archive Range:
                            </div>
                          </td>
                          <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                            <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                              {AdminSettings.archive_range
                                ? AdminSettings.archive_range.replace('_', ' ')
                                : ''}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                            <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                              <span className='icon'>
                                {arcmIcons.autoArchive}
                              </span>{' '}
                              Auto Archive Schedule:
                            </div>
                          </td>
                          <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                            <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                              {'yes' === AdminSettings.enable_auto_archive
                                ? AdminSettings.auto_archive_interval.replace(
                                    '_',
                                    ' '
                                  )
                                : 'Disable'}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className='arcm-export-orders arcm-mt-4 arcm-px-5 arcm-py-6 sm:arcm-px-8 sm:arcm-py-10 md:arcm-px-10 md:arcm-py-12 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-gray-200'>
                  <div className='arcm-text-gray-800 arcm-text-base arcm-font-bold arcm-mb-1.5'>
                    Export orders
                  </div>
                  <div className='arcm-text-gray-600 arcm-text-sm arcm-font-normal arcm-mb-4'>
                    Export your orders in a csv, json, xml or other popular
                    formats
                  </div>
                  <button
                    onClick={() => handleViewChange('export_orders')}
                    class='arcm-text-[#3858e9] arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-border arcm-border-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all arcm-group hover:arcm-bg-[#3858e9] hover:arcm-text-white'
                  >
                    <span className='icon'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                      >
                        <path
                          className='arcm-transition-all group-hover:arcm-stroke-white'
                          d='M1.5 12.75V14.625C1.5 15.6605 2.33947 16.5 3.375 16.5H14.625C15.6605 16.5 16.5 15.6605 16.5 14.625V12.75M12.75 9L9 12.75M9 12.75L5.25 9M9 12.75V1.5'
                          stroke='#3858E9'
                          stroke-width='1.5'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        />
                      </svg>
                    </span>
                    <span>Export Orders</span>
                  </button>
                </div>
              </>
            )}
          </>
        )
      ) : null}
      {activeView === 'archive_settings' && (
        <connectionContext.Provider
          value={{ awsConnection, handleAwsconnection }}
        >
          <ArchiveSettings
            AdminSettings={AdminSettings}
            setAdminSettings={setAdminSettings}
            onvVeiwChange={handleViewChange}
            isPro={isPro}
            falshDoor={falshDoor}
            handleOnboardingComplete={handleOnboardingComplete}
            saveAdminSettings={saveAdminSettings}
            saveBtnLoading={saveBtnLoading}
            archiving={archiving}
            handleArchiveModal={handleToggleModal}
          />
        </connectionContext.Provider>
      )}
      {activeView === 'aws_database' && (
        <connectionContext.Provider
          value={{
            awsConnection,
            handleAwsconnection,
            handleOnboardingComplete,
            rdsCredential
          }}
        >
          <AwsConfigure onvVeiwChange={handleViewChange} />
        </connectionContext.Provider>
      )}
      {activeView === 'archiving_details' && (
        <ArchiveDetails
          queuedOrders={queuedOrders}
          totalOrders={totalOrders}
          archivePercentage={percentage}
          archiving={archiving}
          onvVeiwChange={handleViewChange}
          onCancelArchiving={handleArchiveingChange}
          handleArchiveModal={handleToggleModal}
        />
      )}
      {activeView === 'archiving_log' && (
        <Logs onvVeiwChange={handleViewChange} />
      )}
      {activeView === 'export_orders' && (
        <ExportOrders
          AdminSettings={AdminSettings}
          setAdminSettings={setAdminSettings}
          onvVeiwChange={handleViewChange}
          saveAdminSettings={saveAdminSettings}
          saveBtnLoading={saveBtnLoading}
        />
      )}

      <Modal openModal={isOpen} toggleModal={handleToggleModal}>
        {{
          header: (
            <h5 className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold'>
              Ready to Archive
            </h5>
          ),
          body: (
            <div className='arcm-mb-6 arcm-mt-3'>
              <table className='arcm-w-full arcm-mb-6'>
                <tbody>
                  <tr>
                    <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                      <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                        <span className='icon'>{arcmIcons.database}</span>{' '}
                        Remote Database:
                      </div>
                    </td>
                    <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                      <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                        <span className='arcm-w-3 arcm-h-3 arcm-bg-[#27d935] arcm-rounded-full'>
                          {' '}
                        </span>{' '}
                        Connected to RDS {arcmIcons.aws}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className='arcm-text-gray-700 arcm-text-sm arcm-font-semibold arcm-leading-none arcm-py-2'>
                      <div className=' arcm-inline-flex arcm-items-center arcm-gap-2'>
                        <span className='icon'>{arcmIcons.folder}</span> Post
                        Type:
                      </div>
                    </td>
                    <td className='arcm-text-gray-900 arcm-text-sm arcm-font-nomal arcm-text-right arcm-leading-none arcm-py-2'>
                      <div className='arcm-inline-flex arcm-items-center arcm-gap-2'>
                        {' '}
                        WooCommerce Orders
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className='btn-box arcm-flex arcm-flex-col arcm-items-center arcm-justify-center'>
                {activeView === 'dashboard_settings' && (
                  <button
                    onClick={() => handleArchiveing('archiving__start')}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-mb-4 arcm-min-w-[180px] arcm-px-4 arcm-py-2.5 arcm-bg-[#3858e9] arcm-rounded-lg arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    Start Archiving
                  </button>
                )}
                {activeView === 'archive_settings' && (
                  <button
                    onClick={() => handleArchiveViewSettings()}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-mb-4 arcm-min-w-[180px] arcm-px-4 arcm-py-2.5 arcm-bg-[#3858e9] arcm-rounded-lg arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    Start Archiving
                  </button>
                )}
                {activeView === 'archiving_details' && (
                  <button
                    onClick={() => {
                      setIsOpen(false)
                      return handleArchiveingChange('archiving__start')
                    }}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-mb-4 arcm-min-w-[180px] arcm-px-4 arcm-py-2.5 arcm-bg-[#3858e9] arcm-rounded-lg arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    Start Archiving
                  </button>
                )}
                <button
                  onClick={handleToggleModal}
                  className='arcm-text-[#EF4444] arcm-text-sm arcm-font-semibold arcm-min-w-[180px] arcm-px-4 arcm-py-2.5 arcm-border arcm-border-[#EF4444] arcm-rounded-lg arcm-bg-white arcm-transition-all hover:arcm-bg-[#655857] hover:arcm-text-white'
                >
                  Cancel
                </button>
              </div>
            </div>
          )
        }}
      </Modal>

      <Modal
        openModal={isArchiveFailedOpen}
        toggleModal={handleArchiveFailedToggleModal}
      >
        {{
          header: (
            <h5 className='arcm-text-center arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold'>
              Archive Failed
            </h5>
          ),
          body: (
            <div className='arcm-mb-6'>
              <p className='arcm-text-red-500 arcm-text-sm arcm-font-normal'>
                {archiveFailMeassage}
              </p>
            </div>
          )
        }}
      </Modal>
    </div>
  )
}

export default Settings
